<script>
export default {
  name: "the-header",
  methods: {
    goToHome() {
      window.location.href = process.env.VUE_APP_DOMAIN;
    },
  },
}
</script>

<template>
  <header class="header">
    <img class="header__logo" src="@/assets/imgs/logo.svg" />
    <v-btn
        outlined
        class="header__btn"
        @click="goToHome"
    >
      Sobre nosotros
      <v-icon right>
        mdi-arrow-right
      </v-icon>
    </v-btn>
  </header>
</template>

<style scoped lang="less">
.header {
  height: 2.5rem;
  padding: 0.5rem 0.75rem;
  display: flex;
  justify-content: space-between;
  background: #FFF;
}

.header__btn {
  height: unset !important;
  min-width: unset !important;
  cursor: pointer;
  padding: 0 0.625rem !important;
  border: 1px solid #0AAC5F;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  background: #ffffff;

  :deep {
    .v-btn__content {
      color: #0AAC5F;
      font-size: 0.875rem;
      font-style: normal;
      font-weight: 500;
      line-height: 1.25rem;

      .v-icon {
        margin-left: 0.25rem;
      }
    }
  }
}
</style>